<form [formGroup]="loginForm" class="form-warp">

    <div class="warp-input-select">
        <input class="select" type="text" placeholder="{{'login.username' | translate}}" formControlName="name">
        <mat-error *ngIf="loginForm.controls.name?.invalid && loginForm.controls.name?.touched"
            translate>login.errors.required</mat-error>
    </div>

    <div class="warp-input-select">
        <div class="password-input">
            <input class="select" [type]="showPassword ? 'text' : 'password'"
                placeholder="{{'login.password' | translate}}" formControlName="password">
            <div class="password-icon-warp">
                <img [src]="showPassword ? 'assets/images/login/visibility.png' : 'assets/images/login/visibility_off.png'"
                    alt="Password visibility icon" class="password-icon" (click)="showPassword = !showPassword" />
            </div>
        </div>

        <mat-error *ngIf="loginForm.controls.password?.invalid && loginForm.controls.password?.touched"
            translate>login.errors.required</mat-error>
    </div>
</form>